module.exports = __webpack_public_path__ + "static/img/sol-training.a63cffc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solution/sol-training.jpg
// module id = Vr3f
// module chunks = 1